import { TMessage } from '../../../types/messages';
import { TThumbnail } from '../../../types/thumbnail';
import { getFileSrc } from '../../../utils/getFileSrc';

interface IGetReplyMessageContentProps {
  message: TMessage;
  chatId: string;
}

interface IGetReplyMessageContentResult {
  text: string;
  thumbnail: TThumbnail;
}

export const getReplyMessageContent = ({
  message: { files, offers, message },
  chatId,
}: IGetReplyMessageContentProps): IGetReplyMessageContentResult => {
  /** Документ */
  if (files?.documents?.length) {
    return {
      text: files.documents[0].name,
      thumbnail: { type: 'document' },
    };
  }

  /** Фото как документ */
  if (files?.imagesAsDocuments?.length) {
    const img = files.imagesAsDocuments[0];

    return {
      text: img.name,
      thumbnail: { type: 'image', url: getFileSrc(img.uid, chatId) },
    };
  }

  /** Фото */
  if (files?.images?.length) {
    return {
      text: message || 'Фотография',
      thumbnail: { type: 'image', url: getFileSrc(files.images[0].uid, chatId) },
    };
  }

  /** Оффер */
  if (offers?.length) {
    const offer = offers[0];
    const offerImageUrl = offer.photoUrls?.[0];

    return {
      text: offer.formattedInfo,
      thumbnail: offerImageUrl ? { type: 'image', url: offerImageUrl } : null,
    };
  }

  /** Текст */
  return {
    text: getInlineMessage(message),
    thumbnail: null,
  };
};

/**
 * @description
 * Заменяет переносы строк на пробелы и убирает лишние пробелы
 */
function getInlineMessage(text?: string): string {
  if (!text) {
    return '';
  }

  return text.replace(/\r?\n/g, ' ').trim();
}
